module.exports = __webpack_public_path__ + "img/ttc.719930bf.jpg";